module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"once":"once","interviews":"Interviews","sms":"Text messages","calls":"Calls","price":"Price per month"}}')
  delete Component.options._Ctor
}
